import { defineComponent } from 'vue'
import './index.scss'
export default defineComponent({
  name: 'GfrCarouselSlide',
  setup(_, { slots }) {
    return () => <li class={'gfr-carousel-slide'}>{slots.default?.()}</li>
  }
})
